import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Form, Button, } from 'react-bootstrap'



import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { Link, useNavigate } from 'react-router-dom'


import { userLogoutAction } from '../actions/userActions'
import exportToExcel from '../utils/ExportToExcel'
import ToJalaali from '../utils/ToJalaali'
import jalaali from "jalaali-js"; // پکیج خودتان
import { BASE_URL } from '../constants/urlConstants'
import PersianText from '../components/PersianText'
import { fetchPasargadReport } from '../actions/pasargadReportActions'

function PasargadReportScreen() {

  const history = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const pasargadReport = useSelector(state => state.pasargadReport)
  const { error, loading, pasargadreport } = pasargadReport

// داده‌های اولیه برای دراپ‌دان‌ها
  const years = Array.from({ length: 11 }, (_, i) => 1400 + i); // 1400 تا 1410
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  // استیت‌های تاریخ شمسی (مقدار پیش‌فرض: امروز یا یک بازه خاص)
  const [startDate, setStartDate] = useState({ y: 1403, m: 1, d: 1 });
  const [endDate, setEndDate] = useState({ y: 1403, m: 12, d: 29 });

  const [selectedOption, setSelectedOption] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [selectedCode, setselectedCode] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [message, setMessage] = useState('')

  const TE = "Invalid token specified: must be a string"

  useEffect(() => {
    if (error === TE) {
      dispatch(userLogoutAction());
      history('/login?redirect=/profile');
    }
    if (!userInfo) {
      history('/login')
    }
  }, [history, userInfo, dispatch, error])

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault()//صفحه ریلود نمیشود
    if (!selectedOption && !selectedCode) {
      setMessage('لطفا یک مورد را انتخاب کنید !')
    } else {
       // تبدیل تاریخ شمسی به میلادی برای ارسال به بک‌اِند
        const gStart = jalaali.toGregorian(parseInt(startDate.y), parseInt(startDate.m), parseInt(startDate.d));
        const gEnd = jalaali.toGregorian(parseInt(endDate.y), parseInt(endDate.m), parseInt(endDate.d));

        const startStr = `${gStart.gy}-${String(gStart.gm).padStart(2, '0')}-${String(gStart.gd).padStart(2, '0')}`;
        const endStr = `${gEnd.gy}-${String(gEnd.gm).padStart(2, '0')}-${String(gEnd.gd).padStart(2, '0')}`;

        const searchId = selectedOption || selectedCode;

        dispatch(fetchPasargadReport(searchId, startStr, endStr));
        setMessage('');

      // if (selectedOption) {
      //   dispatch(fetchPasargadReport(selectedOption, startDate, endDate))
      // } else {
      //   dispatch(fetchPasargadReport(selectedCode, startDate, endDate))
      // }
      setSelectedOption('')
      setselectedCode('')
    }
  }

  
  const tableData = pasargadreport.map((item, index) => ({
    "ردیف": index + 1,
    "کد رهگیری": item.customer?.track_code || '-',
    "نام": item.customer?.customer?.name || '-',
    "پک مربوطه": item.customer?.categoryKit || '-',
    "تاریخ تایید پرداخت": item.customer?.paidAt ? ToJalaali(item.customer.paidAt) : '-',
    " تاریخ پرداخت": item.invoiceDate ? ToJalaali(item.invoiceDate) : '-',
    "شماره فاکتور": item.invoice || '-',
    "شماره کارت": item.cardNo || '-',
    "شماره پیگیری": item.trackId || '-'
  }))


  const handlePrint = () => {
    window.print();
  };

  // کامپوننت داخلی برای ردیف‌های انتخاب تاریخ
    const DateSelector = ({ label, value, onChange }) => (
        <Col md={6} className="mb-3">
            <Form.Label className="fw-bold">{label}</Form.Label>
            <div className="d-flex gap-1">
                <Form.Select size="sm" value={value.y} onChange={(e) => onChange({...value, y: e.target.value})}>
                    {years.map(y => <option key={y} value={y}>{y}</option>)}
                </Form.Select>
                <Form.Select size="sm" value={value.m} onChange={(e) => onChange({...value, m: e.target.value})}>
                    {months.map(m => <option key={m} value={m}>{m.toString().padStart(2, '0')}</option>)}
                </Form.Select>
                <Form.Select size="sm" value={value.d} onChange={(e) => onChange({...value, d: e.target.value})}>
                    {days.map(d => <option key={d} value={d}>{d.toString().padStart(2, '0')}</option>)}
                </Form.Select>
            </div>
        </Col>
    );

  console.log(userInfo.name)
  return (

    <div>
      {
        loading ? <Loader />
          : error ? <Message variant='danger' text={error} />
            : message ? <Message variant='danger' text={message} />
              : <></>
      }
      <p className='text-danger large mt-3'> گزارش تراکنش‌های پاسارگاد : </p>
      
        <form onSubmit={handleSubmit} className="bg-light p-3 rounded border mb-4">
          <Row align="center">
              
              {userInfo.name == "mina" ? (
                <div>
              <Col md={3} className='border-start'>
                            <Form.Check type="radio" label="عملیات موفق" name="option" value="5" checked={selectedOption === "5"} onChange={handleOptionChange} />
                            <Form.Check type="radio" label="عملیات ناموفق" name="option" value="6" checked={selectedOption === "6"} onChange={handleOptionChange} />
                            <Form.Check type="radio" label="همه موارد" name="option" value="7" checked={selectedOption === "7"} onChange={handleOptionChange} />
                        </Col>
              {/* <Col md={3} className='pt-3'>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="5"
                        checked={selectedOption === "5"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        عملیات موفق
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="6"
                        checked={selectedOption === "6"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        عملیات ناموفق
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="7"
                        checked={selectedOption === "7"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        همه موارد
                      </label>
                    </div>
               
              </Col> */}
              <Col md={6}>
                        <Row>
                            <DateSelector label="از تاریخ:" value={startDate} onChange={setStartDate} />
                            <DateSelector label="تا تاریخ:" value={endDate} onChange={setEndDate} />
                        </Row>
                    </Col>
              </div>
               ) : ""}
               {/* بخش کد رهگیری */}
                    <Col md={3} className='border-end'>
                        <Form.Group controlId='trackcode'>
                            <Form.Label className="fw-bold">جستجو با کد رهگیری:</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='مثلا 102030'
                                value={selectedCode}
                                onChange={(e) => { setselectedCode(e.target.value); setSelectedOption(""); }}
                            />
                        </Form.Group>
                    </Col>
                {/* <Col md={3} className='pt-2'>    
                <div>
                  <Form.Group controlId='trackcode'>
                    <Form.Label></Form.Label>
                    <Form.Control
                      type='text'
                      name="option"
                      placeholder='کد رهگیری'
                      value={selectedCode}
                      onChange={(e) => setselectedCode(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </div>
              </Col> */}
            </Row>
            <Row>
               <Col>
                        <Button variant="primary" type="submit" className="w-25">نمایش گزارش</Button>
                    </Col>
            </Row>
          
        </form>
      
      <Row>
        <Col>
          <img src={`${BASE_URL}/public/images/logo/exel-icon.png`} onClick={() => exportToExcel(tableData, "table-data")} alt="icon" class="icon"></img>

          <img src={`${BASE_URL}/public/images/logo/print-icon.png`} onClick={handlePrint} alt="icon" class="icon"></img>
        </Col>
      </Row>
      <Row>

        <Table className="table table-sm table-bordered table-warning table-striped table-hover" id="table-to-print">
          <thead>
            <tr className='table-warning'>
              <td className='table-warning text-danger'>ردیف</td>
              <td className='table-warning text-danger'>کد رهگیری</td>
              <td className='table-warning text-danger'>نام</td>
              <td className='table-warning text-danger'>پک مربوطه</td>
              <td className='table-warning text-danger'>تاریخ تایید پرداخت</td>
              <td className='table-warning text-danger'>تاریخ پرداخت</td>
              <td className='table-warning text-danger'>شماره فاکتور</td>
              <td className='table-warning text-danger'> شماره کارت</td>
              <td className='table-warning text-danger'>شماره پیگیری</td>
            </tr>
          </thead>
          <tbody>
            {pasargadreport.map((items, index) => (
              <tr className='table-warning'>
                <td className='table-warning'>{index + 1}</td>
                <td className='table-warning'>
                  
                    <PersianText> {items.customer?.track_code || '-'}</PersianText>
                  
                </td>
                <td className='table-warning'>{items.customer?.customer?.name || '-'}</td>

                <td className='table-warning'><PersianText>کیت شماره {items.customer?.categoryKit || '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.customer?.paidAt ? ToJalaali(items.customer.paidAt) : '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.invoiceDate ? ToJalaali(items.invoiceDate) : '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.invoice || '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.cardNo || '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.trackId || '-'}</PersianText></td>
              </tr>
            ))}
          </tbody>
        </Table>

      </Row>

    </div>



  );
}

export default PasargadReportScreen
